export interface TextPart {
  text: string;
  /** Gesetzt, wenn der Abschnitt als Link gerendert werden soll */
  href?: string;
}

const URL_PATTERN = /(https?:\/\/[^\s<>"]+|www\.[^\s<>"]+)/g;
const TRAILING_PUNCTUATION = /[.,;:!?]+$/;

/**
 * Zerlegt Text in normale Abschnitte und URLs (http/https oder www.),
 * damit Notizen und Zwischenablage-Texte klickbare Links bekommen.
 * Satzzeichen direkt hinter der URL zählen nicht zum Link.
 */
export function splitLinks(text: string): TextPart[] {
  const parts: TextPart[] = [];
  let lastIndex = 0;
  for (const match of text.matchAll(URL_PATTERN)) {
    const index = match.index ?? 0;
    const raw = match[0];
    const trailing = raw.match(TRAILING_PUNCTUATION)?.[0] ?? "";
    const url = raw.slice(0, raw.length - trailing.length);
    const valid = /^https?:\/\/./.test(url) || /^www\.[^.]/.test(url);
    if (index > lastIndex) parts.push({ text: text.slice(lastIndex, index) });
    if (valid) {
      parts.push({
        text: url,
        href: url.startsWith("www.") ? `https://${url}` : url,
      });
      lastIndex = index + url.length;
    } else {
      parts.push({ text: raw });
      lastIndex = index + raw.length;
    }
  }
  if (lastIndex < text.length) parts.push({ text: text.slice(lastIndex) });
  return parts;
}
